import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { useHistory } from 'react-router-dom';
import { ROOT_PATH } from '../constants/RouteConstants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NotFoundPage = () => {
  const history = useHistory();
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    type: "notFound",
    "data-test-id": "404-page",
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.pageNotFound.subTitle"
      })
    }), /*#__PURE__*/_jsx(Link, {
      onClick: () => history.push(ROOT_PATH),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.pageNotFound.linkToArticlesPage"
      })
    })]
  });
};
export default NotFoundPage;